import { h } from "preact";
import { useEffect, useRef } from "preact/hooks";
import FollowDesinger from "./followDesigner";

export default function DesignersList({
  designers,
  title,
  idPrefix,
  loggedIn,
}) {
  const letterRef = useRef(null);
  useEffect(() => {
    if (window.location.hash && window.location.hash == `#${idPrefix}-${title}`) {
      letterRef.current.scrollIntoView({ behavior: "smooth" });
    }
  });
  designers.forEach((designer) => {
    try {
      new URL(designer.collection.onlineStoreUrl).pathname;
    } catch (error) {
      console.log(error, designer);
    }
  });
  return (
    <li className="designers__entries-list-item">
      <h3 className="designers__letter" id={`${idPrefix}-${title}`} ref={letterRef}>
        {title}
      </h3>
      <ul className="designers__list">
        {designers.map((designer) => (
          <li className="designers__list-item">
            {loggedIn && (
              <FollowDesinger
                className="follow-designer--flag"
                name={designer.name}
                collectionHandle={designer.collection.handle}
              />
            )}
            <a
              className="designers__list-item-link"
              href={designer.collection.onlineStoreUrl ? new URL(designer.collection.onlineStoreUrl).pathname : 'javascript:void(0);'}
            >
              {designer.name}
            </a>
          </li>
        ))}
      </ul>
    </li>
  );
}
